<template>
  <div class="my-page">
    <div class="user-section">
      <img src="@/assets/images/avatar.png" class="user-avatar" />
      <div class="user-info">
        <span class="user-name">{{userInfo.username}}</span>
        <span class="user-phone">{{userInfo.mobile}}</span>
      </div>
    </div>
    
    <div class="menu-list">
      <div class="menu-item" @click="goToPage('privacy')">
        <img src="@/assets/images/document.png" class="menu-icon" />
        <span>{{decryptLabel('Es4c4My3oRUjoR7zvTby0w==')}}</span>
      </div>
      
      <div class="menu-item" @click="goToPage('notice')">
        <img src="@/assets/images/rate.png" class="menu-icon" />
        <span>{{decryptLabel('4wUZUT6/8jj+2PNsh+Ce8Q==')}}</span>
      </div>
      
      <div class="menu-item" @click="goToPage('contract')">
        <img src="@/assets/images/document.png" class="menu-icon" />
        <span>{{decryptLabel('sdztUsomFuEnyhtIdwfkgA==')}}</span>
      </div>
      
      <div class="menu-item" @click="goToPage('user-info')">
        <img src="@/assets/images/user-info-icon.png" class="menu-icon" />
        <span>{{decryptLabel('GK4Tqc8yHiYxvtJsmRaTsQ==')}}</span>
      </div>
    </div>
    
    <button class="logout-btn" @click="handleLogout">退出登录</button>
  </div>
</template>

<script>
import { getStorage, removeStorage } from '@/utils/storage'
import { decryptData } from '@/utils/security'

export default {
  data() {
    return {
      userInfo: {
        username: "张三",
        id_num: "",
        mobile: "13800138111",
        card_num: "",
        repaymenttime: "",
        repaymenttime1: "",
        overdue_day: "",
        money: "",
        overdue_money: "",
        repayable_amount: ""
      }
    }
  },
  
  created() {
    this.loadUserInfo()
  },
  methods: {
    decryptLabel(encryptedLabel) {
      return decryptData(encryptedLabel);
    },
    goToPage(page) {
      this.$router.push(`/${page}`)
    },
    async loadUserInfo() {
      try {
        const userInfo = getStorage('userInfos')
        if (userInfo) {
          this.userInfo = userInfo
        } else {
          const storeUserInfo = this.$store.state.user.userInfo
          if (storeUserInfo) {
            this.userInfo = storeUserInfo
          }
        }
      } catch (error) {
      }
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', {
        title: '确认退出',
        icon: 'warning',
        confirmType: 'danger'
      }).then(async () => {
        await this.logout()
      }).catch(() => {})
    },
    
    async logout() {
      try {
        const result = await this.$store.dispatch('user/logout')
        
        if (result.success) {
          this.$success(result.message || '退出成功').then(() => {
            this.$router.push('/login')
          })
        } else {
          this.$error(result.message || '退出失败')
        }
        
      } catch (error) {
        this.$error('退出失败，请重试')
      }
    }
  }
}
</script>

<style scoped>
.my-page {
  padding: 14px;
  background: linear-gradient(180deg, #f0fdf4 0%, #f8fafc 100%);
  min-height: 100vh;
  padding-bottom: calc(72px + env(safe-area-inset-bottom));
}

.user-section {
  background: linear-gradient(145deg, #ffffff 0%, #f0fdf4 100%);
  border-radius: 20px;
  padding: 24px 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 8px 28px rgba(15, 181, 76, 0.1);
  min-height: 110px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  position: relative;
  overflow: hidden;
}

.user-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(to right, #0FB54C, #8DC641);
}

.user-avatar {
  width: 92px;
  height: 92px;
  border-radius: 50%;
  margin-right: 16px;
  border: 3px solid #dcfce7;
  box-shadow: 0 6px 16px rgba(15, 181, 76, 0.25);
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.user-section:active .user-avatar {
  transform: scale(0.96);
}

.user-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.user-name {
  font-size: 19px;
  font-weight: 800;
  color: #111827;
  letter-spacing: 0.6px;
}

.user-phone {
  font-size: 15px;
  color: #6b7280;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.menu-list {
  margin-bottom: 18px;
}

.menu-item {
  display: flex;
  align-items: center;
  background: linear-gradient(145deg, #ffffff 0%, #fafafa 100%);
  border-radius: 16px;
  padding: 18px 20px;
  margin-bottom: 12px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
  min-height: 48px;
  position: relative;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid transparent;
  cursor: pointer;
}

.menu-item::after {
  content: '›';
  position: absolute;
  right: 18px;
  font-size: 22px;
  color: #cbd5e1;
  font-weight: 300;
}

.menu-item:active {
  transform: translateY(2px) scale(0.98);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-color: #dcfce7;
  background: linear-gradient(145deg, #f0fdf4 0%, #ecfdf5 100%);
}

.menu-icon {
  width: 30px;
  height: 30px;
  margin-right: 18px;
  filter: drop-shadow(0 2px 4px rgba(15, 181, 76, 0.18));
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-item:active .menu-icon {
  transform: scale(0.94);
}

.menu-item span {
  font-size: 15px;
  color: #374151;
  font-weight: 700;
  letter-spacing: 0.3px;
}

.logout-btn {
  width: 88%;
  margin: 0 auto;
  display: block;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: #fff;
  border-radius: 16px;
  height: 52px;
  line-height: 52px;
  font-size: 16px;
  font-weight: 800;
  box-shadow: 0 5px 16px rgba(239, 68, 68, 0.35);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  border: none;
  cursor: pointer;
  letter-spacing: 0.5px;
}

.logout-btn:active {
  transform: translateY(2px) scale(0.98);
  box-shadow: 0 3px 10px rgba(239, 68, 68, 0.4);
}
</style>
